/* eslint-disable jsx-a11y/label-has-associated-control */
import classNames from 'classnames';

export default function InputLabel({ label, className, ...props }) {
  return (
    <label
      className={classNames('block font-bold mb-2 text-sm', className)}
      {...props}
    >
      {label}
    </label>
  );
}
